var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_1820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9 13.8H2.1C0.9 13.8 0 12.9 0 11.7V2.1C0 0.9 0.9 0 2.1 0H14.9C16.1 0 17 0.9 17 2.1V11.7C17 12.9 16.1 13.8 14.9 13.8ZM2.1 1C1.5 1 1 1.5 1 2.1V11.7C1 12.3 1.5 12.8 2.1 12.8H14.9C15.5 12.8 16 12.3 16 11.7V2.1C16 1.5 15.5 1 14.9 1H2.1Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49998 8.20008C8.39998 8.20008 8.29998 8.20008 8.19998 8.10008L0.199984 2.50008C-1.62125e-05 2.40008 -0.100016 2.00008 0.0999838 1.80008C0.299984 1.60008 0.599984 1.50008 0.799984 1.70008L8.49998 7.10008L16.2 1.70008C16.4 1.50008 16.7 1.60008 16.9 1.80008C17.1 2.00008 17 2.40008 16.8 2.50008L8.79998 8.10008C8.69998 8.20008 8.59998 8.20008 8.49998 8.20008Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_1820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 13.8,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.65908e9f152a299f100ad58fab54df02.svg";
export { ForwardRef as ReactComponent };